import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useContext } from 'react';

import Button from 'Common/Button';

import { VitalSignsContext } from '../../vital-signs.context';
import DialogVitalSign from '../Form/DialogVitalSign';

export default function Add() {
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(VitalSignsContext);
  const closeDialog = useCallback(
    success => {
      setNewDialogOpened(false);

      if (success) {
        reload();
      }
    },
    [reload, setNewDialogOpened]
  );

  const onClick = () => {
    setNewDialogOpened(true);
  };
  return (
    <>
      <Button startIcon={<AddIcon />} variant="contained" color="primary" onClick={onClick} className="mt-1">
        Vital Ölçümü Ekle
      </Button>

      <DialogVitalSign onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
